import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - not convinced banner';

export default {
  ...defineTracking({
    sliderDotNav: {
      category,
      action: 'click',
      label: 'slider dot nav button',
      description: 'This event is triggered when a user clicks to navigate via slider dots.',
    },
    scrollNav: {
      category,
      action: 'scroll',
      label: '{site}',
      description:
        'This event is triggered when a user navigates to a site card by scrolling. ' +
        '{site} represents the site the user scrolled to.',
    },
    curtainStatus: {
      category,
      action: 'scroll',
      label: '{status} curtain',
      description:
        'This event is triggered when a user scrolls the curtain. {status} represents the status of the curtain.',
    },
  }),
};
